import { CalendarRange } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { OnboardingPhase } from "@forgepoint/shared";
import { OnboardingGantt } from "./OnboardingGantt";

interface OnboardingScheduleCardProps {
  phases: OnboardingPhase[];
  scheduleStart: string | null;
  scheduleEnd: string | null;
  goLiveDate: string | null;
}

/**
 * The go-live schedule card, rendering the phase timeline gantt. Renders
 * nothing until the plan's schedule range (start and end) is set.
 */
export function OnboardingScheduleCard({
  phases,
  scheduleStart,
  scheduleEnd,
  goLiveDate,
}: OnboardingScheduleCardProps) {
  if (!scheduleStart || !scheduleEnd) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <CalendarRange className="h-4 w-4" />
          Go-live schedule
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <OnboardingGantt
          phases={phases}
          scheduleStart={scheduleStart}
          scheduleEnd={scheduleEnd}
          goLiveDate={goLiveDate}
        />
      </CardContent>
    </Card>
  );
}
